module.exports = __webpack_public_path__ + "static/media/NavigationLogo.72947135.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/NavigationLogo.svg
// module id = 95
// module chunks = 0